import {
    CardContent,
    Typography
} from '@mui/material';
import { useUnit } from 'effector-react';
import { $userData } from '../store/userData';

const CarCard = ({ car }) => {

    const userData = useUnit($userData);

    const hasActiveSubscription = () => {
        return new Date(userData.subscriptionEndData) > new Date();
    }

    return (
        <div style={{padding: "5px"}}>
            <Typography variant="h6">
                {car.model.name}
            </Typography>
            {car.description.split("\n").map((text, index) => (
                <p style={{ textAlign: "left", margin: 0, overflowWrap: "break-word" }} key={index}>{text}</p>

            ))}
            {hasActiveSubscription() &&
                <div style={{ display: 'flex', flexDirection: 'column', wordBreak: 'break-all' }}>
                    <a target="_blank" href={car.media}>
                        📸 Подробная информация об авто и фото
                    </a>

                    <a target="_blank" href={car.report}>
                        🔎 Отчёт автотеки
                    </a>
                </div>}

        </div>
    );
};

export default CarCard;